import React, { useState, useRef, useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import { Autoplay } from 'swiper/modules'
import { Button } from 'src/modules/molecules/button'
import TitleLockup from 'src/modules/molecules/title-lockup'
import * as styles from './TestimonialsLoop.module.scss'

interface TestimonialsLoopProps {
  title: string
  titleAlt: string
  description: string
  buttonText: string
  slides?: string[]
}

// Component is rigidly designed to show 3 slides at a time
// Needs to be exaclty 4 slides to work properly
// Potentially refactor to custom, non-swiper solution
const TestimonialsLoop: React.FC<TestimonialsLoopProps> = ({
  title,
  titleAlt,
  description,
  buttonText,
  slides = [
    '/assets/images/testimonials/lucas.jpg',
    '/assets/images/testimonials/misha.jpg',
    '/assets/images/testimonials/geoff.jpg',
    '/assets/images/testimonials/misha.jpg'
  ]
}) => {
  const prevRef = useRef<HTMLButtonElement>(null)
  const nextRef = useRef<HTMLButtonElement>(null)
  const [visibleSlides, setVisibleSlides] = useState<number[]>([])

  const handleSlideChange = (swiper: any) => {
    const totalSlides = slides.length
    const activeIndex = swiper.realIndex
    const prevIndex = (activeIndex - 1 + totalSlides) % totalSlides
    const nextIndex = (activeIndex + 1) % totalSlides

    setVisibleSlides([prevIndex, activeIndex, nextIndex])
  }

  useEffect(() => {
    if (prevRef.current && nextRef.current) {
      const swiperElement = document.querySelector('.swiper') as HTMLElement & {
        swiper: any
      }
      const swiper = swiperElement?.swiper
      if (swiper) {
        swiper.params.navigation.prevEl = prevRef.current
        swiper.params.navigation.nextEl = nextRef.current
        swiper.navigation.init()
        swiper.navigation.update()
      }
    }
  }, [])

  return (
    <section className={styles.testimonials}>
      <div className={styles.testimonialsContainer}>
        <div className={styles.testimonialsContent}>
          <TitleLockup headingLevel="h3" visualStyle="h3" title={title} titleAlt={titleAlt} />
          <hr />
          <p>{description}</p>
          <Button variant="secondary" size="medium" className={styles.testimonialsButton}>
            {buttonText}
          </Button>
        </div>
        <div className={styles.testimonialsSwiper}>
          <Swiper
            modules={[Autoplay]}
            loop={true}
            slidesPerView={3}
            spaceBetween={-200}
            centeredSlides={true}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            className="testimonials-swiper"
            onSlideChange={handleSlideChange}
          >
            {slides.map((image, index) => (
              <SwiperSlide
                key={index}
                className={`testimonials-swiper__slide ${
                  visibleSlides.includes(index) ? '' : 'hidden-slide'
                }`}
              >
                <img src={image} alt={`Testimonial ${index + 1}`} />
              </SwiperSlide>
            ))}
          </Swiper>
          <img src="/assets/logos/awards/awards.png" alt="Quote" />
        </div>
      </div>
    </section>
  )
}

export default TestimonialsLoop
